import { laptopMediumMin, tabletMin } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { Container as PropertyDescription } from '../PropertyDescription.style';
import { CounterContainer, PhotoCounter } from '../PropertySlider.style';
import { Container as SlideshowLinks, Content as SlideshowLinksContent } from '../SlideshowLinks.style.pn';

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
`;

export const Wrapper = styled.div`
  padding: 16px;

  @media (${tabletMin}) {
    padding: 24px;
  }
`;

export const Content = styled.div`
  @media (${laptopMediumMin}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 32px;
  }

  ${PropertyDescription} {
    margin: 0;
  }
`;

export const SliderContainer = styled.div`
  margin-bottom: 32px;
  padding-bottom: 70px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.keyline};
  position: relative;

  .swiper {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }

  ${SlideshowLinks} {
    position: initial;

    ${SlideshowLinksContent} {
      bottom: 16px;
      top: auto;
      left: 16px;
    }
  }

  ${PhotoCounter} {
    bottom: 93px;
    right: 16px;
  }

  ${CounterContainer} {
    bottom: -80px;
  }
`;
